export enum SubjectType {
    Event = "sEVENT", // Complete state of the event
    Evall = "sEVALL",
    Market = "sEVMKT", // Complete state of the market
    MarketDescendants = "SEVMKT", // Complete state of the market
    Outcome = "sSELCN", // Complete state of the outcome
    Price = "sPRICE", // Live price of the outcome
    Score = "sSCORE",
    Clock = "sCLOCK",
    BetCash = "BETCSH",
    // Ignored subjects
    Handicap = "sMHCAP", // Handicap/line of the market
    Stats = "sSTATS",
    Eppnt = "sEPPNT",
    Pturn = "sPTURN",
}
